module.exports = __webpack_public_path__ + "static/media/RP-67.8f1c094a.pdf";